var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 4H9V6H11V4Z",
    fill: "#FFA556"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 8H9V16H11V8Z",
    fill: "#FFA556"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 3V2H18V1H17V0H3V1H2V2H1V3H0V17H1V18H2V19H3V20H17V19H18V18H19V17H20V3H19ZM18 15H17V16H16V17H15V18H5V17H4V16H3V15H2V5H3V4H4V3H5V2H15V3H16V4H17V5H18V15Z",
    fill: "#FFA556"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/InfoIcon.eb16620a.svg";
export { ForwardRef as ReactComponent };